import React, { Component } from 'react';
import ProjectComponent from "../components/project/project.component";
class PastProjectContainer extends Component {
    render() {
        const data = this.props.data;
        const projects = data.map(item =>
            <ProjectComponent key={item.name} projectName={item.name} tags={item.tags} intro={item.intro} url={item.url} description={item.description} />
        )
        return (
            <section id="section-past-projects">
                <div className="container">
                    <div className="jumbotron">
                        <h1>Past Projects</h1>
                        <p>I've been involved in numerous projects of varying size and complexity over my professional experience. This
                            includes
                    <em>designing and coding web 2.0 sites, peer-to-peer applications</em>,
                    and <em>mobile apps</em>. Projects listed below are the ones that demonstrate my diverse range of skills.
                </p>
                        <button className="btn btn-primary btn-lg" id="toggle-past-projects">Show Details</button>

                        <ul id="past-projects" className="projects hide">
                            {projects}
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

export default PastProjectContainer;



// WEBPACK FOOTER //
// ./src/containers/pastProject.container.jsx